module.exports = __webpack_public_path__ + "img/hot-sale.97f31a88.png";